var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-list-widget',{attrs:{"org-ref":_vm.orgRef,"title":"leads","entity-type":"lead","board-link":"leadBoard","read-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }